<template>
    <v-container fluid grid-list-xl class="pt-3">
        <v-flex xs6>
            <v-card class="pa-2 mb-3">
                <v-card-title class="pb-1" primary-title>
                    <h3 class="headline my-0">
                        Account ID:
                        {{ account.accountID }}
                    </h3>
                </v-card-title>
                <v-card-text class="mb-2 pb-0 pt-2">
                    <h4 class="card-title font-weight-medium mt-2 mb-2">
                        {{ account.name }}
                    </h4>
                    <p class="mb-0">
                        {{ account.hname }}
                    </p>
                    <div class="ml-2 pl-1 mt-4 pt-2">
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium mr-2">
                                Address:
                            </div>
                            <div>
                                {{ account.address1 }}
                            </div>
                        </v-layout>
                        <v-layout row class="mb-2" v-if="account.emailAddress">
                            <div class="font-weight-medium mr-2">
                                Email:
                            </div>
                            <div>
                                {{ account.emailAddress }}
                            </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium mr-2">
                                Father:
                            </div>
                            <div>
                                {{ account.father }}
                            </div>
                        </v-layout>
                        <v-layout row class="mb-2" v-if="account.shver">
                            <div class="font-weight-medium mr-2">
                                Shver:
                            </div>
                            <div>
                                {{ account.shver }}
                            </div>
                        </v-layout>
                    </div>
                </v-card-text>
                <div style="margin-left: 4px;" class="mt-2">
                    <v-layout
                        style="width: 250px"
                        row
                        class="my-2 pl-1 ml-2"
                        v-if="account.homePhone"
                    >
                        <div class="font-weight-medium mr-2">
                            Home Phone
                        </div>
                        <div>
                            {{ account.homePhone }}
                        </div>
                    </v-layout>
                    <v-layout
                        style="width: 250px"
                        row
                        class="my-2 pl-1 ml-2"
                        v-if="account.cellPhone"
                    >
                        <div class="font-weight-medium mr-2">
                            Cell Phone
                        </div>
                        <div>
                            {{ account.cellPhone }}
                        </div>
                    </v-layout>
                </div>
            </v-card>
        </v-flex>
        <v-flex xs6>
            <v-card class="pa-2">
                <v-card-title class="headline py-2 pl-1 ml-2"
                    >Food Distribution</v-card-title
                >
                <div
                    class="ml-4 pt-4"
                    v-if="foodDistributionInfo && foodDistributionInfo.familyID"
                >
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                            Enrolled:
                        </div>
                        <div>
                            {{ foodDistributionInfo.enrolled }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                            Enrolled Date:
                        </div>
                        <div>
                            {{ foodDistributionInfo.enrolledDate | time }}
                        </div>
                    </v-layout>
                </div>
                <v-form ref="foodDistributionInfoForm" lazy-validation>
                    <v-container>
                        <v-layout wrap>
                            <!-- <v-flex xs6 class="py-0">
                                <v-text-field
                                    label="Large Boxes"
                                    v-model="largeBoxesOverride"
                                />
                            </v-flex>
                            <v-flex xs6 class="py-0">
                                <v-text-field
                                    label="Small Boxes"
                                    v-model="smallBoxesOverride"
                                />
                            </v-flex> -->
                            <v-flex xs12 class="py-0">
                                <v-text-field
                                    label="Reason"
                                    v-model="overrideReason"
                                    :rules="[rules.required]"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex class="xs12 text-xs-right mt-3">
                                <v-btn
                                    dark
                                    color="default"
                                    @click.stop="cancel"
                                    class="mr-2"
                                    >cancel</v-btn
                                >
                                <v-btn
                                    v-if="
                                        foodDistributionInfo &&
                                            foodDistributionInfo.familyID
                                    "
                                    dark
                                    color="default"
                                    @click.stop="openRemoveDialog"
                                    class="mr-2"
                                    >Remove</v-btn
                                >
                                <v-btn
                                    :loading="processing"
                                    :disabled="!account.accountID"
                                    color="success"
                                    @click.stop="save"
                                    >Save</v-btn
                                >
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card>
        </v-flex>
        <v-dialog v-model="removeDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2">
                    This will remove {{ this.account.name }} from the food
                    distribution
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="removeDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="remove">
                        Remove
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        account: "",
        foodDistributionInfo: "",

        largeBoxesOverride: "",
        smallBoxesOverride: "",
        overrideReason: "",

        processing: false,

        removeDialog: false,

        rules: {
            required: (value) => !!value || "Required.",

            // boxes: [
            //     (value) =>
            //         this.largeBoxesOverride ||
            //         this.smallBoxesOverride ||
            //         !!value ||
            //         "Required.",
            // ],
        },
    }),
    watch: {},
    async created() {
        this.loadAccount();
        this.loadFoodDistributionInfo();
    },
    methods: {
        async loadAccount() {
            const account = await this.$http.get(
                "api/accounts/getAccount?accountID=" + this.$route.params.id
            );

            this.account = account;
        },
        async loadFoodDistributionInfo() {
            const foodDistributionInfo = await this.$http.get(
                "api/foodDistributionAccountInfo/GetForAccount?accountID=" +
                    this.$route.params.id
            );

            this.foodDistributionInfo = foodDistributionInfo;

            this.overrideReason = this.foodDistributionInfo.overrideReason;
            this.smallBoxesOverride = this.foodDistributionInfo.smallBoxesOverride;
            this.largeBoxesOverride = this.foodDistributionInfo.largeBoxesOverride;
        },
        cancel() {
            this.$router.push({
                name: "Account View",
                params: { id: this.account.accountID },
            });
        },
        openRemoveDialog() {
            this.removeDialog = true;
        },
        async remove() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/foodDistributionAccountInfo/RemoveFamily?accountID=" +
                        this.account.accountID
                );

                this.processing = false;
                this.removeDialog = true;

                this.$notify({
                    text: "Family Removed From Food Distribution.",
                    group: "notification",
                    type: "success",
                });

                this.$router.push({
                    name: "Account View",
                    params: { id: this.account.accountID },
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async save() {
            if (!this.$refs.foodDistributionInfoForm.validate()) return;

            // if (!this.largeBoxesOverride && !this.smallBoxesOverride) {
            //     this.$notify({
            //         text: "Please enter boxes.",
            //         group: "notification",
            //         type: "error",
            //     });

            //     return;
            // }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/foodDistributionAccountInfo/AddFamily",
                    {
                        accountID: this.account.accountID,
                        smallBoxesOverride: this.smallBoxesOverride,
                        largeBoxesOverride: this.largeBoxesOverride,
                        overrideReason: this.overrideReason,
                    }
                );

                this.processing = false;

                this.$notify({
                    text: "Family Added To Food Distribution.",
                    group: "notification",
                    type: "success",
                });

                this.$router.push({
                    name: "Account View",
                    params: { id: this.account.accountID },
                });
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.v-btn__content {
    color: unset;
}
</style>
